import React, { useState, useEffect } from 'react';
import api from '../../Services/Api';
import styles from './MotivationalQuote.module.css';

const MotivationalQuoteModal = ({ onClose }) => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    fetchDailyQuote();

    // Auto close after 3 seconds
    const timer = setTimeout(() => {
      handleClose();
    }, 3000);

    // Close on any user interaction
    const closeOnInteraction = () => {
      handleClose();
    };

    window.addEventListener("click", closeOnInteraction);
    window.addEventListener("keydown", closeOnInteraction);
    window.addEventListener("touchstart", closeOnInteraction);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("click", closeOnInteraction);
      window.removeEventListener("keydown", closeOnInteraction);
      window.removeEventListener("touchstart", closeOnInteraction);
    };
  }, []);

  const fetchDailyQuote = async () => {
    try {
      setLoading(true);
      const response = await api.get('daily_quote/');
      setQuote(response.data);
      console.log('Fetched motivational quote:', response.data);
    } catch (error) {
        console.error('Error fetching motivational quote:', error);
      
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (isClosing) return;

    setIsClosing(true);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };

  if (loading) {
    return (
      <div className={styles.modalOverlay}>
        <div className={styles.modalContentSmall}>
          <div className={styles.spinnerSmall}></div>
          <p>Loading inspiration...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.modalOverlay} ${isClosing ? styles.closing : ''}`}>
      <div className={styles.modalContentSmall}>
        <blockquote className={styles.quoteText}>
          "{quote?.message || quote?.text}"
        </blockquote>
        <div className={styles.quoteAuthor}>
          — {quote?.author || "Unknown"}
        </div>
      </div>
    </div>
  );
};

export default MotivationalQuoteModal;
